<template>
  <div class="menu-page">
    <div class="menu-inner" :style="{ backgroundImage: bgImage }">
      <div class="menu-content">
        <div v-if="currentMeal" class="meal-box">
          <div
            class="scroll-wrapper"
            :class="{ 'auto-scroll': scroll }"
          >
            <div class="columns-row" :class="{ 'single-col': categoryColumns.length === 1 }" ref="scrollContent">
              <div
                v-for="(col, colIdx) in categoryColumns"
                :key="colIdx"
                class="category-column"
              >
                <div
                  v-for="cat in col"
                  :key="cat.name"
                  class="category-group"
                >
                  <div class="category-name">{{ cat.name }}</div>
                  <div class="dish-list">
                    <div
                      v-for="(dish, dIdx) in cat.dishes"
                      :key="dIdx"
                      class="dish-item"
                    >
                      <span class="dish-name">{{ dish.name }}</span>
                      <span class="dish-price">{{ dish.price }}元</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 滚动模式下复制一份实现无缝循环 -->
            <!-- <div v-if="scroll" class="columns-row" :class="{ 'single-col': categoryColumns.length === 1 }">
              <div
                v-for="(col, colIdx) in categoryColumns"
                :key="'dup-' + colIdx"
                class="category-column"
              >
                <div
                  v-for="cat in col"
                  :key="cat.name"
                  class="category-group"
                >
                  <div class="category-name">{{ cat.name }}</div>
                  <div class="dish-list">
                    <div
                      v-for="(dish, dIdx) in cat.dishes"
                      :key="dIdx"
                      class="dish-item"
                    >
                      <span class="dish-name">{{ dish.name }}</span>
                      <span class="dish-price">{{ dish.price }}元</span>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchScreenData } from '../utils/api.js'

export default {
  name: 'MenuPage',
  data() {
    return {
      meals: [],
      scroll: false,
      screenPhoto: false,
      screenPhotoUrl: ''
    }
  },
  computed: {
    currentMeal() {
      return this.meals.length > 0 ? this.meals[0] : null
    },
    categoryColumns() {
      if (!this.currentMeal) return []
      const cats = this.currentMeal.categories
      if (cats.length <= 3) return [cats]
      return [cats.slice(0, 3), cats.slice(3)]
    },
    bgImage() {
      if (this.screenPhoto && this.screenPhotoUrl) {
        return `url(${this.screenPhotoUrl})`
      }
      return ''
    }
  },
  mounted() {
    this.loadMenu()
  },
  methods: {
    async loadMenu() {
      try {
        const res = await fetchScreenData()
        // 新格式：{ menu_data, scroll, screen_photo, screen_photo_url }
        const menuData = res.menu_data || res
        this.scroll = res.scroll || false
        this.screenPhoto = res.screen_photo || false
        this.screenPhotoUrl = res.screen_photo_url || ''
        this.buildMenuMap(Array.isArray(menuData) ? menuData : [])
      } catch (error) {
        console.error('获取菜单失败:', error)
      }
    },

    buildMenuMap(list) {
      const mealMap = {}

      list.forEach(item => {
        const mealName = item.dinner_type_id
        const catName = item.dish_top_category_id
        const dishName = item.dish
        if (!mealName || !catName || !dishName) return

        if (!mealMap[mealName]) {
          mealMap[mealName] = { cats: {} }
        }
        if (!mealMap[mealName].cats[catName]) {
          mealMap[mealName].cats[catName] = []
        }
        mealMap[mealName].cats[catName].push({
          name: dishName,
          price: item.price
        })
      })

      this.meals = Object.keys(mealMap).map(name => ({
        name,
        categories: Object.keys(mealMap[name].cats).map(cat => ({
          name: cat,
          dishes: mealMap[name].cats[cat]
        }))
      }))
    }
  }
}
</script>

<style scoped>
.menu-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  padding: 20px;
  background-color: #ffffff;
}

.menu-inner {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: url('../assets/今日食谱.png') center / cover no-repeat;
}

.menu-content {
  margin-left: 25%;
  width: 75%;
  height: 100%;
  padding: 16px 32px 16px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (min-width: 1920px) {
  .menu-content {
    margin-left: 30%;
    width: 65%;
  }
}

.meal-box {
  width: 100%;
  background: rgba(255, 255, 255, 0.88);
  height: 80vh;
  overflow: hidden;
}

.scroll-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.scroll-wrapper.auto-scroll .columns-row {
  animation: menuScroll 30s linear infinite;
}

@keyframes menuScroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}

.columns-row {
  display: flex;
  gap: 40px;
}

.category-column {
  flex: 1;
  display: block;
  margin-bottom: 32px;
  border-left: 1px solid #d0dbe8;
  padding-left: 24px;
}

.single-col .category-column {
  flex: none;
  width: 50%;
}

.category-group {
  display: block;
  margin-bottom: 32px;
}

.category-group:last-child {
  margin-bottom: 0;
}

.category-name {
  color: #1a706f;
  font-size: 25px;
  font-weight: 600;
  padding: 2px 10px;
  background: rgba(26, 112, 111, 0.08);
  border-radius: 4px;
  display: inline-block;
  width: fit-content;
  margin-bottom: 6px;
}

.dish-list {
  display: block;
  padding-left: 6px;
}

.dish-item {
  margin-bottom: 10px;
}

.dish-item::after {
  content: '';
  display: table;
  clear: both;
}

.dish-item:last-child {
  margin-bottom: 0;
}

.dish-name {
  float: left;
  color: #3d4f5f;
  font-size: 23px;
}

.dish-price {
  float: right;
  color: #3d4f5f;
  font-size: 23px;
  margin-left: 20px;
}

/* scrollbar */
.menu-content::-webkit-scrollbar {
  width: 4px;
}
.menu-content::-webkit-scrollbar-thumb {
  background: #c0cdda;
  border-radius: 2px;
}
</style>
